import React, { useState, useRef, useEffect } from 'react';

const DEFAULT_HEIGHT = 600;

export default function MapHeightContainer({ children }) {
    const containerRef = useRef(null);
    const [height, setHeight] = useState(DEFAULT_HEIGHT);

    useEffect(() => {
        const element = containerRef.current;
        if (!element) return undefined;

        const updateHeight = () => {
            const nextHeight = Math.max(element.clientHeight, 300);
            setHeight(nextHeight);
        };

        updateHeight();

        const observer = new ResizeObserver(updateHeight);
        observer.observe(element);

        return () => observer.disconnect();
    }, []);

    return (
        <div ref={containerRef} className="delivery-map-page__map-area">
            {children(height)}
        </div>
    );
}
